import Ply from './Ply'
import CMS from './CMS'
import Commerce from './Commerce'
import ERP from './ERP'
import Reports from './Reports'

const adminApps = [Ply, CMS, Commerce, ERP, Reports]

export default adminApps
